import { render, staticRenderFns } from "./Socio-noregister.vue?vue&type=template&id=2d81ffb2&scoped=true"
import script from "./Socio-noregister.vue?vue&type=script&lang=js"
export * from "./Socio-noregister.vue?vue&type=script&lang=js"
import style0 from "./Socio-noregister.vue?vue&type=style&index=0&id=2d81ffb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d81ffb2",
  null
  
)

export default component.exports